<!--
 * @Author: wsx
 * @Date: 2022-01-12 14:57:29
 * @LastEditTime: 2022-06-15 09:37:14
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: 新增/编辑用户表单
-->
<template>
  <el-dialog
    v-model="formVisible"
    :title="formTitle"
    @close="close"
    width="40%"
    top="5vh"
  >
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      :disabled="isDisabled"
      label-width="120px"
      class="userForm"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          v-model="ruleForm.username"
          placeholder="长度应为2到18个字符"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password" v-if="status == 1">
        <el-radio-group v-model="passwordType">
          <el-radio :label="1">使用默认密码</el-radio>
          <el-radio :label="2">单设置密码</el-radio>
        </el-radio-group>
        <el-input
          v-if="passwordType == 2"
          v-model="ruleForm.password"
          placeholder="请输入密码"
          type="password"
        ></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="身份证号" prop="card">
        <el-input
          v-model="ruleForm.card"
          placeholder="请输入身份证号"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phoneNum">
        <el-input
          v-model.number="ruleForm.phoneNum"
          type="number"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="员工号" prop="jobNum">
        <el-input
          v-model="ruleForm.jobNum"
          placeholder="请输入员工号"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="roleIdList">
        <el-select
          v-model="ruleForm.roleIdList"
          multiple
          placeholder="请选择角色"
          style="width: 100%"
        >
          <el-option
            v-for="item in options"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group v-model="ruleForm.status">
          <el-radio label="1">启用</el-radio>
          <el-radio label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="obj.backUpField1" v-if="obj.backUpField1">
        <el-input v-model="ruleForm.backUpField1"></el-input>
      </el-form-item>
      <el-form-item :label="obj.backUpField2" v-if="obj.backUpField2">
        <el-input v-model="ruleForm.backUpField2"></el-input>
      </el-form-item>
      <el-form-item :label="obj.backUpField3" v-if="obj.backUpField3">
        <el-input v-model="ruleForm.backUpField3"></el-input>
      </el-form-item>
      <el-form-item :label="obj.backUpField4" v-if="obj.backUpField4">
        <el-input v-model="ruleForm.backUpField4"></el-input>
      </el-form-item>
      <el-form-item :label="obj.backUpField5" v-if="obj.backUpField5">
        <el-input v-model="ruleForm.backUpField5"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <template v-if="!isDisabled">
        <h-button type="primary" @click="submitForm(ruleFormRef)"
          >保存</h-button
        >
        <h-button @click="resetForm(ruleFormRef)">重置</h-button>
        <h-button @click="formVisible = false">取消</h-button>
      </template>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  computed,
  toRefs,
  watchEffect,
  ref,
} from "vue";
import util from "@util/js";
import Validate from "@/utils/validate.js";
import { updateUser, addUser } from "@/api/user";
import { getDict } from "@/api/constant";
import { ElMessage } from "element-plus";
import _ from "lodash";
import { getRoleSelect } from "@/api/system/role";
export default defineComponent({
  name: "userForm",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      defaultPassword: "a123456", // kzga110
      formVisible: false,
      passwordType: 1,
      ruleForm: {
        password: "kzga110",
        name: "",
        sex: "1",
        status: "1",
        userId: "",
        deptId: props.form.deptId || "",
        deptName: "",
        username: "",
        card: "",
        roleIdList: [],
        backUpField1: "",
        backUpField2: "",
        backUpField3: "",
        backUpField4: "",
        backUpField5: "",
      },
      obj: {},
      ruleFormBack: {},
      rules: {
        username: [
          {
            required: true,
            validator: validate.userName,
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur",
          },
        ],
        jobNum: [
          {
            required: true,
            message: "请输入员工号",
            trigger: "blur",
          },
        ],
        roleIdList: [
          {
            required: true,
            message: "请选择角色",
            trigger: "blur",
          },
        ],
      },
      options: [],
      formTitle: "",
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    if (props.status === 1) {
      state.rules.card = [
        {
          required: true,
          validator: validate.iDCard,
          trigger: "blur",
        },
      ];
      state.rules.phoneNum = [
        {
          required: true,
          validator: validate.tel,
          trigger: "blur",
        },
      ];
    }
    // 初始化表单
    const initForm = () => {
      if (props.status !== 1) {
        state.passwordType = 2;
      }
      const form = { ...state.ruleForm, ...props.form };
      state.ruleForm = _.cloneDeep(form);
    };
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
      const types = [2, 3];
      console.log(props.modelValues, props.status, 111111111);
      if (types.includes(props.status)) {
        initForm();
      }
      if (props.status === 1) {
        state.formTitle = "添加";
        state.rules.password = [
          {
            required: true,
            validator: validate.password,
            trigger: "blur",
          },
        ];
      } else if (props.status === 2) {
        state.formTitle = "编辑";
        if (Reflect.has(state.rules, "password")) {
          Reflect.deleteProperty(state.rules, "password");
        }
        Reflect.deleteProperty(state.rules, "card");
        state.ruleForm.card = "";
      } else if (props.status === 3) {
        state.formTitle = "详情";
      }
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    // 监听密码设置状态
    watchEffect(() => {
      if (state.passwordType === 1) {
        state.ruleForm.password = state.defaultPassword;
      } else {
        state.ruleForm.password = "";
      }
    });
    // 获取角色列表
    const getRoleSelectAsync = async () => {
      const res = await getRoleSelect();
      state.options = res.list;
    };
    getRoleSelectAsync();
    // 禁用
    const isDisabled = computed(() => {
      return props.status === 3;
    });
    const refData = toRefs(state);

    // 保存表单数据
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          form.deptId = props.form.parentId;
          util.formatForm(form);
          let res;
          if (props.status === 1) {
            res = await addUser(form);
          } else if (props.status === 2) {
            res = await updateUser(form);
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            context.emit("submit");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
      resetForm(ruleFormRef.value);
    };

    const getDictAxios = async () => {
      const res = await getDict("back_up_field");
      console.log(res, "iiiiiiiii");
      const obj = {};
      res.dict.forEach((item) => {
        if (item.remark === "true") {
          obj["backUpField" + item.code] = item.value;
        }
      });
      state.obj = obj;
      state.ruleForm = { ...state.ruleForm };
      console.log(state.ruleForm, obj, "iiiiiiiii");
    };
    watchEffect(() => {
      getDictAxios();
    });
    return {
      ...refData,
      submitForm,
      isDisabled,
      resetForm,
      close,
      ruleFormRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.userForm {
}
</style>
